<template>
  <div class="spaigge-widget">
    <div class="wg-row icons">
      <div
        v-for="(c, i) in components"
        :key="'comp-' + i"
        :class="c.id"
        :title="c.title"
        @click="openDialog(c)"
      >
        <img
          class="com-anm22-app-img-fixed-height-l"
          style="padding: 5px; height: 100%"
          :src="$anm22.icons.getWorldIcon(c.icon)"
        />
      </div>
      <div
        class="new-form"
        :title="$anm22.strLang(this.lang, 'New test', 'Nuova scheda analisi')"
        @click="openNewForm()"
      >
        <img
          class="com-anm22-app-img-fixed-height-l"
          style="padding: 5px; height: 100%"
          :src="$anm22.icons.getWorldIcon('add')"
        />
      </div>
    </div>
    <wg-modal
      :width="windowWidth > 700 ? '600px' : '90%'"
      v-if="showModal"
      @closeModal="closeDialog"
      :portal="true"
    >
      <div slot="header" class="com-anm22-app-text-xl">{{ dialogTitle }}</div>
      <component
        slot="body"
        :is="selectedCustomComponent"
        :projectId="project.idWorldProject"
        :contact="customer"
      ></component>
    </wg-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String]
  },
  data() {
    return {
      docs: {},
      showModal: false,
      selectedCustomComponent: "",
      dialogTitle: ""
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    customer() {
      if (this.project.customers.length > 0) {
        return this.$store.getters["contacts/get"](this.project.customers[0]);
      } else {
        return null;
      }
    },
    components() {
      let components = [];
      components.push({
        id: "ecodemolizioni-test",
        title: this.$anm22.strLang(
          this.lang,
          "Analysis",
          "Analisi"
        ),
        component: "EcodemolizioniTest",
        icon: "fileDefault"
      });
      return components;
    }
  },
  methods: {
    openDialog(obj) {
      this.dialogTitle = obj.title;
      this.selectedCustomComponent = obj.component;
      this.showModal = true;
    },
    closeDialog() {
      this.showModal = false;
    },
    openNewForm() {
      window.open('https://www.anm22.it/app/tasks/forms/form.html?id=2&cantiere=' + this.projectId, '_blank');
    }
  },
  async created() {},
  components: {
    EcodemolizioniTest: () => import(/* webpackChunkName: "custom-6" */ "./EcodemolizioniTest.vue"),
  }
};
</script>

<style lang="scss" scoped>
.spaigge-widget .icons {
  align-items: center;
  font-size: 0;
  padding: 5px 0 0 0;
  flex-wrap: nowrap;
}
.spaigge-widget .icons div {
  border-radius: 30px;
  width: 60px;
  height: 60px;
  background-color: #ddd;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 10px;
  margin: 5px 10px;
  cursor: pointer;

  &:hover {
    background-color: #ccc;
  }
}
</style>

